export const getPortDefaultFilterOptions = () => {
  return {
    year: new Date().getFullYear().toString(),
    month: [],
    region: [],
    ship: [],
  }
}
